module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/constructor.c99613d75c6ceb6a48c52d0c0c4b9747.jpg";